import React from "react";

import {
  ChartSeriesType,
  DateTimelineProps,
} from "@/components/organisms/DateTimeline/DateTimeline.types";
import { DateTimelineBarSeries } from "@/components/organisms/DateTimeline/DateTimelineBarSeries";
import { DateTimelineLineSeries } from "@/components/organisms/DateTimeline/DateTimelineLineSeries";

interface DateTimelineSeriesProps<T> {
  chartBarLikeSeriesIndices: Map<number, number>;
  chartGroup: d3.Selection<SVGGElement, unknown, null, undefined> | null;
  chartHeight: number;
  chartSeriesBandwidth: number;
  data: T[];
  dateKey: keyof T;
  seriesStyles: any[];
  floatingGap: number;
  isInitialized: React.MutableRefObject<boolean>;
  series: ChartSeriesType[];
  tooltip?: DateTimelineProps<T>["tooltip"];
  xScale: d3.ScaleBand<Date>;
  yScale: d3.ScaleLinear<number, number>;
  selectedRange?: [Date, Date] | null;
}

export function DateTimelineSeries<T>({
  chartBarLikeSeriesIndices,
  chartGroup: g,
  chartHeight,
  chartSeriesBandwidth,
  data,
  dateKey,
  seriesStyles,
  floatingGap,
  isInitialized,
  series,
  tooltip,
  xScale,
  yScale,
  selectedRange,
}: DateTimelineSeriesProps<T>) {
  if (!g) return null;

  return (
    <>
      {series.map((s, i) => {
        if (s.isExcludedFromChart) return null;

        if (s.type === "bar") {
          const barIndex = chartBarLikeSeriesIndices.get(i)!;
          return (
            <DateTimelineBarSeries
              key={i}
              g={g}
              series={s}
              xScale={xScale}
              yScale={yScale}
              data={data}
              dateKey={dateKey}
              seriesIndex={barIndex}
              chartSeriesBandwidth={chartSeriesBandwidth}
              isInitialized={isInitialized}
              chartHeight={chartHeight}
              floatingGap={floatingGap}
              style={seriesStyles[i]}
            />
          );
        }

        if (s.type === "line") {
          return (
            <DateTimelineLineSeries
              key={i}
              g={g}
              series={s}
              xScale={xScale}
              yScale={yScale}
              data={data}
              dateKey={dateKey}
              seriesIndex={i}
              isInitialized={isInitialized}
              style={seriesStyles[i]}
              tooltip={tooltip}
              selectedRange={selectedRange}
              chartHeight={chartHeight}
            />
          );
        }

        return null;
      })}
    </>
  );
}
